<template>
  <QS-scroller-box>
    <EchoLastData
      :dataList="leaseSetupPreview"
      :model="renderData.model.topPreviewModel"
    />
    <!-- 租赁方案选择 -->
    <QS-h4-title title="租赁方案选择" />
    <form-text-box
      ref="leaseScheme"
      :column="3"
      :dataList="renderData.list.leaseSchemeList"
      :model="renderData.model.leaseSchemeModel"
      :rules="renderData.rules.leaseSchemeRules"
    />
    <!-- 车型选择 -->
    <QS-h4-title title="车型选择" />
    <el-form :model="renderData.model.vehicleModelModel" ref="modelFormRef" :rules="renderData.rules.vehicleModelRules">
      <QS-column-box :column="2" style="align-items: flex-start;">
        <CarBrandSeriesModel
          ref="carBrandSeriesModelRef"
          v-model="brandSeriesModel"
          :disabled="brandDisabled"
          :brandSeriesModelName="brandSeriesModelName"
          :showModel="true"
          :filterScene="CAR_MODEL_FILTER_SCENE.IN_STOCK">
        </CarBrandSeriesModel>
      </QS-column-box>
    </el-form>
    <!-- 租赁信息 -->
    <QS-h4-title title="租赁信息"/>
    <!-- 确认租赁信息 -->
    <rentInfo
      ref="rentInfo"
      :planId="selectPlanId"
      :isEnterChildOrder="true"
      @updateInfo="updateRentDateInfo"
    />
    <!-- 租赁信息文本展示和支付计划表格 -->
    <rentLeasePlanInfo
      ref="rentLeasePlanInfo"
      :defaultTableData="feeTableData"
      :rentDateInfo="rentDateInfo"
      @autoAnchor="autoAnchor"
    />
    <template slot="bottomAction">
      <el-button @click="cancel" size="mini">取消</el-button>
      <el-button @click="previousStep" size="mini">上一步</el-button>
      <el-button @click="confirm" size="mini" type="primary">确认，下一步</el-button>
    </template>
  </QS-scroller-box>
</template>
<script>
// api
import { getLeasingSchemeConfigList } from '@/api/domain/cars'
import { maintenancePlanList } from '@/api/domain/carsService'
import { providerList } from '@/api/global'
import { leaseSetupPreview } from '../../config/echoLastData'
// 组件
import rentInfo from '@/components/rentCalculateConfig/rentInfo.vue'
import rentLeasePlanInfo from '@/components/rentCalculateConfig/rentLeasePlanInfo.vue'
import moment from 'moment'
import { mapState } from 'vuex'
import EchoLastData from '../../../components/EchoLastData.vue'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

export default {
  components: {
    EchoLastData,
    rentInfo,
    rentLeasePlanInfo,
  },
  props: {
    renderData: {
      type: Object,
      default: () => ({}),
    },
    leaseInfoParams: {
      type: Object,
      default: () => ({}),
    },
    tableDataFrom: {
      type: Object,
      default: () => ({}),
    },
    maitenaceParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      leaseSetupPreview,
      // eslint-disable-next-line vue/no-unused-properties
      show: true,
      // eslint-disable-next-line vue/no-unused-properties
      disabledStartStopDate: false,
      from_check: {}, // 校验结果
      providerList: [], // 维修厂
      maintenancePlanList: [], // 维保方案
      rentPlanList: [], // 方案列表
      selectPlanId: null,
      rentDateInfo: {
        category: '', // 类别
        signDate: '', // 签署日期
        startStopDate: '', // 收款起止日期
        presentDays: '', // 赠送天数
        isTranDeposit: '', // 是否平移原订单押金 1-是 0-否
        contractDateText: '', // 合同起止日期文本 eg: 2023-07-01~2023-07-31
        rentPeriodText: '', // 租期文本(天数) eg: 共7天
        presentDaysText: '', // 赠送天数文本 eg: 0天
      },
      feeTableData: [],
      brandSeriesModel: {},
      brandSeriesModelName: {}, // 品牌车系名称
      CAR_MODEL_FILTER_SCENE,
    }
  },
  computed: {
    ...mapState({
      categoryList: (state) => {
        // 企业签约提车没有司机合作模式
        return state.global.categoryList.filter((item) => item.code !== 3) // 类别
      },
    }),
    brandDisabled() {
      return !!this.renderData.model.leaseSchemeModel.planId
    },
  },
  watch: {
    brandSeriesModel: {
      handler(val) {
        const { brandId, seriesId, modelId } = val
        /* eslint-disable vue/no-mutating-props */
        this.renderData.model.vehicleModelModel.brandId = brandId
        this.renderData.model.vehicleModelModel.seriesId = seriesId
        this.renderData.model.vehicleModelModel.modelId = modelId
        this.$nextTick(() => {
          this.$refs.modelFormRef.clearValidate('brandId')
          this.$refs.modelFormRef.clearValidate('modelId')
        })
      },
      deep: true,
    },
  },
  provide() {
    return {
      deposit: {
        flag: 0,
      },
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    updateRentDateInfo(val, feeTableData) {
      this.rentDateInfo = {
        ...val,
      }
      this.feeTableData = feeTableData
    },
    autoAnchor(toastFlag) {
      this.$refs.rentInfo.autoAnchorPoint(toastFlag)
    },
    // eslint-disable-next-line vue/no-unused-properties
    planChange(id) {
      if (!id) {
        this.$refs.rentInfo.resetFormData()
        const {
          model: {
            vehicleModelModel,
            leaseSchemeModel,
          },
        } = this.renderData
        // 租赁方案id
        leaseSchemeModel.planId = 0
        this.selectPlanId = id
        // 车型选择
        vehicleModelModel.modelId = ''
        this.brandSeriesModel = {}
        this.brandSeriesModelName = {}
        // 维保方案
        // eslint-disable-next-line vue/no-mutating-props
        this.maitenaceParams.providerId = ''
        this.maintenancePlanListFn()
        // eslint-disable-next-line vue/no-mutating-props
        this.maitenaceParams.maintenancePlanId = ''
        // 预租周期
        this.rentPeriod = null
        return
      }

      this.rentPlanList.forEach((item) => {
        if (id === item.id) {
          this.selectPlanId = Number(item.id)
          const {
            model: {
              vehicleModelModel,
            },
          } = this.renderData
          // 回显品牌车系车型
          vehicleModelModel.modelId = item.modelId
          this.brandSeriesModel = {
            brandId: item.brandId,
            seriesId: item.seriesId,
            modelId: item.modelId,
          }
          this.brandSeriesModelName = {
            brandName: item.brandName,
            seriesName: item.seriesName,
            modelName: item.modelName,
          }
          // 维保方案
          // eslint-disable-next-line vue/no-mutating-props
          this.maitenaceParams.providerId = item.providerId
          this.maintenancePlanListFn(item.providerId)
          // eslint-disable-next-line vue/no-mutating-props
          this.maitenaceParams.maintenancePlanId = item.maintenancePlanId
        }
      })
    },
    // 取消
    cancel() {
      this.$emit('cancel')
    },
    // 上一步
    previousStep() {
      // 清空数据，租赁方案默认为自定义，品牌车系车型清空
      this.renderData.model.leaseSchemeModel.planId = 0
      this.brandSeriesModel = {}
      this.renderData.model.vehicleModelModel.brandId = ''
      this.renderData.model.vehicleModelModel.seriesId = ''
      this.renderData.model.vehicleModelModel.modelId = ''
      this.$emit('previousStep')
    },
    // 确认
    confirm() {
      // 租赁方案校验
      this.$refs.leaseScheme.getRefs().validate((valid) => {
        this.from_check.leaseScheme = valid
      })
      // 车型选择校验
      this.$refs.modelFormRef.validate((valid) => {
        this.from_check.modelFormRef = valid
      })
      if (!this.from_check.vehicleModel) {
        this.$refs.modelFormRef.$el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
      }
      // 校验所有表单是否通过
      const isfin = Object.keys(this.from_check).every(
        (item) => this.from_check[item],
      )
      if (!isfin) {
        this.$message.error('请填写带有红色 * 的内容')
        return false
      }

      if (!this.$refs.rentInfo.getFormData() || !this.$refs.rentLeasePlanInfo.getFormData()) return

      // 处理支付计划数据
      // eslint-disable-next-line vue/no-mutating-props
      this.leaseInfoParams = Object.assign(this.leaseInfoParams, this.$refs.rentInfo.getFormData())
      // eslint-disable-next-line vue/no-mutating-props
      this.tableDataFrom.tableData = this.$refs.rentLeasePlanInfo.getFormData()
      const accruedPlanParamList = this.tableDataFrom.tableData.map((item) => {
        return { feeType: item.fundType, feeAmount: item.totalAmount }
      })

      this.$refs.rentLeasePlanInfo.orderAccruedplanvalidAccruedPlanAmount(accruedPlanParamList).then((res) => {
        if (res?.code === 1) {
          this.handelToppreview()
          this.$emit('confirm')
        }
      })
    },
    // 保存顶部预览数据
    handelToppreview() {
      const { model } = this.renderData
      const { leaseSchemeModel, vehicleModelModel, topPreviewModel } = model
      // 租赁方案
      const plan = this.rentPlanList.filter((item) => {
        return leaseSchemeModel.planId === item.id
      })[0]
      topPreviewModel.planName = plan?.name || ''
      // 获取车型名称
      const { brandSeries, model: modelLabel } = this.$refs.carBrandSeriesModelRef.getLabels()
      topPreviewModel.modelName = modelLabel.matchValue
      topPreviewModel.brandName = brandSeries.matchValue.split('/')?.[0]
      topPreviewModel.seriesName = brandSeries.matchValue.split('/')?.[1]
      topPreviewModel.modelId = vehicleModelModel.modelId
      // 租赁类型
      const rentCategory = this.categoryList.filter((item) => {
        return this.leaseInfoParams.rentCategory === item.code
      })[0]
      topPreviewModel.categoryName = rentCategory.name
      // 收款起止日期
      topPreviewModel.startStopDate = `${moment(this.leaseInfoParams.startStopDate[0]).format('YYYY-MM-DD')}至${moment(this.leaseInfoParams.startStopDate[1]).format('YYYY-MM-DD')}`
    },
    init() {
      // 获取付款方式
      this.$store.dispatch('getPaymentMethods', { type: 'rentCategory' })
      // 获取方案列表
      this.getLeasingSchemeConfigList()
      // 获取维修厂/服务商数据
      this.getProviderList()
      // 填充品牌车系车型数据
      const {
        brandId, seriesId, modelId,
      } = this.renderData.model.vehicleModelModel
      this.brandSeriesModel = {
        brandId,
        seriesId,
        modelId,
      }
      const { brandName, seriesName, modelName } = this.renderData.model.topPreviewModel || {}
      this.brandSeriesModelName = {
        brandName,
        seriesName,
        modelName,
      }
      this.$nextTick(() => {
        this.$refs.modelFormRef.clearValidate('brandId')
        this.$refs.modelFormRef.clearValidate('modelId')
      })
    },
    // 获取租赁方案
    getLeasingSchemeConfigList() {
      getLeasingSchemeConfigList({
        orderType: 2, // 1 个人  2企业
        state: 1,
        pageNum: 1,
        pageSize: 99999,
      }).then((res) => {
        const { data } = res
        const { items } = data
        this.rentPlanList = [{ id: 0, name: '自定义' }, ...(items || [])]
        this.$refs.leaseScheme.setItemData({ elConfigKey: 'list', key: 'planId', data: this.rentPlanList })
        const selectedPlanId = this.renderData.model.leaseSchemeModel.planId
        const isHave = this.rentPlanList.some((i) => i.id === Number(selectedPlanId))
        if (!isHave) {
          // eslint-disable-next-line vue/no-mutating-props
          this.renderData.model.leaseSchemeModel.planId = ''
        }
      })
    },
    // 修改维修厂
    // eslint-disable-next-line vue/no-unused-properties
    changeProvider(providerId) {
      this.maintenancePlanList = []
      this.$refs.maintenancePlanId.resetField()
      if (providerId) this.maintenancePlanListFn(providerId)
    },
    // 获取维修厂/服务商数据
    async getProviderList() {
      const pararms = {
        serviceType: 1,
        pageNum: 1,
        pageSize: 999,
        state: 1,
      }
      const { code, data } = await providerList(pararms)
      if (code === 1) {
        this.providerList = data.items
      }
    },
    // 获取维保方案列表
    async maintenancePlanListFn(providerId) {
      const pararms = {
        providerId,
        state: 1,
        pageNum: 1,
        pageSize: 999,
      }
      const { code, data = [] } = await maintenancePlanList(pararms)
      if (code === 1) {
        this.maintenancePlanList = data.items
      }
    },
  },
  activated() {
    // 公司侧不再进行请求车型。0-集团侧
    // 获取方案列表
    this.getLeasingSchemeConfigList()
    // 获取付款方式
    this.$store.dispatch('getPaymentMethods', { type: 'rentCategory' })
    // 获取维修厂/服务商数据
    this.getProviderList()
  },
}
</script>
